// Navigation tab Names under KPIs page
export const NAV_TAB_KPI_USAGE = 'Usage';
export const NAV_TAB_KPI_CRASHES = 'Crashes';
export const NAV_TAB_KPI_PERFORMANCE = 'Performance';
export const NAV_TAB_MOBILE_DASHBOARD = 'MobileDashboard';
export const ALL_TYPE_APP = { key: 'all', label: 'All' };
